import "./SwitchPage.css"
import Home from "../Home/Home";
import RecepDocs from "../RecepDocs/RecepDocs";
import SendDocs from "../SendDocs/SendDocs";
import ModifyPassword from "../ModifyPassword/ModifyPassword";
import MyAccount from "../MyAccount/MyAccount";
import FivesPolicy from "../FivesPolicy/FivesPolicy";
import {useRecoilValue} from "recoil";
import User from "../../Model/User";
import { useState } from "react";
import { useUserActions } from "../../../Connect/_actions";
import Button from "../../Model/Button";
import ExternalDocs from "../ExternalDocs/ExternalDocs";
import LoadData from "../../LoadData/LoadData";
import { Role } from "../../Useful/enum";
import { userAtom } from "../../RecoilApp";
import Loc from "../../../Loc/Loc";

interface PageProps {
    page: string;
    setPageOnClick: (page: string) => void;
}

export default function SwitchPage (props: PageProps) {
    const user: User = useRecoilValue(userAtom);
    const userActions = useUserActions();

    const [isModifyPasswordLoading, setIsModifyPasswordLoading] = useState(false);
    const HandleButtonDisconnectOnClick = () => {
        userActions.logout();
    }
    const buttonChangePW: Button = {className : "btn btn-primary", type : "submit", title : Loc.trad().SwitchPagePassword, onClick : () => {}, isLoading : isModifyPasswordLoading};
    const buttonDisconnect: Button = {className : "btn btn-dark", type : "button", title : Loc.trad().SwitchPageDisconnect, onClick : HandleButtonDisconnectOnClick, isLoading : false};

    const buttons = [buttonChangePW, buttonDisconnect];

    LoadData(user);

    return (
        user.role === Role.PermUser ?
            props.page === "Home" ?
                <Home setPageOnClick={props.setPageOnClick}></Home> :
            props.page === "RecepDocs" ?
                <RecepDocs></RecepDocs> :
            props.page === "SendDocs" ?
                <SendDocs></SendDocs> :
            props.page === "ExternalDocs" ?
                <ExternalDocs></ExternalDocs> :
            props.page === "MyAccount" ?
                <MyAccount setPageOnClick={props.setPageOnClick}></MyAccount> :
            <FivesPolicy></FivesPolicy> :
        <ModifyPassword firstConnection={true} buttons={buttons} setIsLoading={setIsModifyPasswordLoading}></ModifyPassword>
    )
}